import { Role } from "../helper/role";

export const RouteScreens = {
  Home: "Home",
  ManagePlayerCareerStats: "ManagePlayerCareerStats",
  EditCareerStatsOnPlayerProfile: "EditCareerStatsOnPlayerProfile",
  PlayerProfileEdit: "PlayerProfileEdit",
  ViewPlayerProfile: "ViewPlayerProfile",
  AdminPreferences: "AdminPreferences",
  AdminBallotDashboard: "AdminBallotDashboard",
  AdminManagePermissions: "AdminManagePermissions",
  AdminManageUsers: "AdminManageUsers",
  AdminGameAudit: "AdminGameAudit",
  TeamBallotDashboard: "TeamBallotDashboard",
  TeamGreenBallotVote: "TeamGreenBallotVote",
  CombineResults: "CombineResults",
  ComparePlayers: "ComparePlayers",
  CareerStatsDashboard: "CareerStatsDashboard",
  BoxScore: "BoxScore",
  TeamGLeagueBallot: "GLeagueBallot",
  EventCalendar: "EventCalendar",
};

const RouteRolePermission = {
  [RouteScreens.Home]: [
    Role.Admin,
    Role.League,
    Role.Team,
    Role.CombineBallotUser,
    Role.DraftGreenRoomBallotUser,
    Role.DraftGLeagueBallotVoteUser,
  ],
  [RouteScreens.AdminPreferences]: [Role.Admin],
  [RouteScreens.AdminBallotDashboard]: [Role.Admin],
  [RouteScreens.AdminManagePermissions]: [Role.Admin],
  [RouteScreens.AdminManageUsers]: [Role.Admin],
  [RouteScreens.AdminGameAudit]: [Role.Admin],
  [RouteScreens.ViewPlayerProfile]: [
    Role.Admin,
    Role.League,
    Role.Team,
    Role.CombineBallotUser,
    Role.DraftGreenRoomBallotUser,
    Role.DraftGLeagueBallotVoteUser,
  ],
  [RouteScreens.PlayerProfileEdit]: [Role.Admin, Role.League],
  [RouteScreens.EditCareerStatsOnPlayerProfile]: [Role.Admin, Role.League],
  [RouteScreens.TeamBallotDashboard]: [Role.CombineBallotUser],
  [RouteScreens.TeamGreenBallotVote]: [Role.DraftGreenRoomBallotUser], // Role.DraftGreenRoomUser
  [RouteScreens.ManagePlayerCareerStats]: [Role.Admin],
  [RouteScreens.CombineResults]: [
    Role.Admin,
    Role.League,
    Role.Team,
    Role.CombineBallotUser,
    Role.DraftGreenRoomBallotUser,
    Role.DraftGLeagueBallotVoteUser,
  ], // Role permissions to be discussed with Chandra
  [RouteScreens.ComparePlayers]: [
    Role.Admin,
    Role.League,
    Role.Team,
    Role.CombineBallotUser,
    Role.DraftGreenRoomBallotUser,
    Role.DraftGLeagueBallotVoteUser,
  ], // Role permissions to be discussed with Chandra
  [RouteScreens.CareerStatsDashboard]: [
    Role.Admin,
    Role.League,
    Role.Team,
    Role.CombineBallotUser,
    Role.DraftGreenRoomBallotUser,
    Role.DraftGLeagueBallotVoteUser,
  ],
  [RouteScreens.BoxScore]: [
    Role.Admin,
    Role.League,
    Role.Team,
    Role.CombineBallotUser,
    Role.DraftGreenRoomBallotUser,
    Role.DraftGLeagueBallotVoteUser,
  ],
  [RouteScreens.TeamGLeagueBallot]: [Role.DraftGLeagueBallotVoteUser],
  [RouteScreens.EventCalendar]: [
    Role.Admin,
    Role.League,
    Role.Team,
    Role.CombineBallotUser,
    Role.DraftGreenRoomBallotUser,
    Role.DraftGLeagueBallotVoteUser,
  ],
};

function IsAuthorized(screenName, userAssignedRoles) {
  return userAssignedRoles.some((r) =>
    RouteRolePermission[screenName].includes(r)
  );
}

export const RoutePermissions = {
  IsAuthorized,
};
